import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import { Grid, Table, Segment, Image, Card } from 'semantic-ui-react';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';

import { loadPayments } from './actions';
import { renderCurrencySymbol } from '../../utils/helpers/currencies';

const commaFormat = num => numeral(num).format('0,0');


const summaryRow = {
  padding: '20px 30px 0px 30px',
};

class Payments extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    onLoadPayments: PropTypes.func.isRequired,
    payments: PropTypes.object.isRequired,
    paymentsLoading: PropTypes.bool.isRequired,
    campaign: PropTypes.object.isRequired,
  };

  static defaultProps = {
    paymentsError: '',
  };

  componentWillMount() {
    console.log(this.props);
    return this.props.onLoadPayments(this.props.params.id);
  }

  getBudgetTotal = array => _.sumBy(array, 'budget');

  render() {
    const { payments, paymentsLoading, campaign } = this.props;
    const teamDiscussion = payments && payments.teamDiscussion;
    const clientDiscussion = payments && payments.clientDiscussion;

    const currency = campaign.get('currency');

    const liveDate = campaign.get('liveDate');

    return (
      <Segment loading={paymentsLoading} basic>
        <div style={{ margin: 10 }}>
          <h2>Fees</h2>
          <br />

          <Card fluid>
            <Grid>
              <Grid.Row>
                <Grid.Column width={5} style={summaryRow}>
                  <p>Total influencer budget</p>
                  <h2>{ renderCurrencySymbol(currency) } {payments && commaFormat(payments.budget)}</h2>
                </Grid.Column>
                <Grid.Column width={5} style={summaryRow}>
                  <p>Allocated</p>
                  <h2>{ renderCurrencySymbol(currency) }
                    {
                      payments &&
                        payments.discussions &&
                        commaFormat(this.getBudgetTotal(payments.discussions))
                    }
                  </h2>
                  <p className="small light">remaining budget { renderCurrencySymbol(currency) }{
                    payments &&
                      payments.discussions &&
                      commaFormat(payments.budget - this.getBudgetTotal(payments.discussions))
                  }</p>
                </Grid.Column>
                <Grid.Column width={6} style={summaryRow}>
                  <p>Live date</p>
                  <h2>
                    { liveDate
                      ? moment(liveDate).format('DD MMM YYYY')
                      : <p className="small light">not set</p>
                    }
                  </h2>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={16}>
                  <Table unstackable style={{ borderLeft: 0, borderRight: 0 }}>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>Influencer</Table.HeaderCell>
                        <Table.HeaderCell textAlign="center">Fee Agreed?</Table.HeaderCell>
                        <Table.HeaderCell textAlign="center">Influencer Fee</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      { payments &&
                          payments.discussions &&
                          _.map(payments.discussions, discussion => {
                            const isTeamDiscussion = discussion.id === teamDiscussion;
                            const isClientDiscussion = discussion.id === clientDiscussion;
                            const influencer = discussion.members && discussion.members[0];

                            let icon = null;

                            switch (discussion.budgetStatus) {
                            case 'PROPOSED':
                              icon = 'pending.svg';
                              break;
                            case 'APPROVED':
                              icon = 'complete.svg';
                              break;
                            case 'REJECTED':
                              icon = 'error-small.svg';
                              break;
                            default:
                              icon = 'incomplete.svg';
                              break;
                            }

                            if (!isClientDiscussion && !isTeamDiscussion) {
                              return (
                                <Table.Row key={discussion.id}>
                                  <Table.Cell verticalAlign="middle">
                                    {
                                      influencer
                                        ? <h2>{influencer.name}&nbsp;<span className="small light">{discussion.name}</span></h2>
                                        : <h2>{discussion.name}&nbsp;<span className="small light" style={{ color: 'red' }} /></h2>
                                    }

                                  </Table.Cell>
                                  <Table.Cell textAlign="center">
                                    <img src={`/icons/${icon}`} alt={discussion.budgetStatus} />
                                  </Table.Cell>
                                  <Table.Cell collapsing style={{ padding: '0 40px' }}><h2>&nbsp;{ renderCurrencySymbol(currency) }{commaFormat(discussion.budget)}&nbsp;</h2></Table.Cell>
                                </Table.Row>
                              );
                            }
                            return null;
                          })}
                      <Table.Row style={{ backgroundColor: '#F9FAFB' }}>
                        <Table.Cell colSpan="2" textAlign="right">
                          <h2>Total allocated Fees</h2>
                        </Table.Cell>
                        <Table.Cell style={{ padding: '0 40px' }}>
                          <h2>&nbsp;{ renderCurrencySymbol(currency) }
                            {payments &&
                              payments.discussions &&
                              commaFormat(this.getBudgetTotal(payments.discussions))}&nbsp;
                          </h2>
                        </Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Card>
        </div>
      </Segment>
    );
  }
}

const mapStateToProps = state => ({
  campaign: state.campaign.get('campaign'),
  payments: state.payments.get('payments'),
  paymentsLoading: state.payments.get('paymentsLoading'),
  paymentsError: state.payments.get('paymentsError'),
});

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onLoadPayments: id => dispatch(loadPayments(id)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Payments);



/** WEBPACK FOOTER **
 ** ./src/containers/payments/index.js
 **/